var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestsList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_24917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 23H14V25H22V23Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23H10V25H12V23Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18H14V20H22V18Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18H10V20H12V18Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13H14V15H22V13Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13H10V15H12V13Z",
    fill: "#C1C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 5H22V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2H12C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V28C5 28.5304 5.21071 29.0391 5.58579 29.4142C5.96086 29.7893 6.46957 30 7 30H25C25.5304 30 26.0391 29.7893 26.4142 29.4142C26.7893 29.0391 27 28.5304 27 28V7C27 6.46957 26.7893 5.96086 26.4142 5.58579C26.0391 5.21071 25.5304 5 25 5ZM12 4H20V8H12V4ZM25 28H7V7H10V10H22V7H25V28Z",
    fill: "#C1C7CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_24917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsList);
export default __webpack_public_path__ + "static/media/requests_list.ef90e5afaec860b37bc4f6df9445a957.svg";
export { ForwardRef as ReactComponent };